import { MARKETPLACE_TOKEN, REST_URL } from 'constants/index';
import { MarketplaceServices } from 'services';
import { handleBaseURL } from 'services/api';

let refreshRequest: any = null;

export const getMarketplaceToken = async (config: any): Promise<string> => {
  try {
    const { url, params } = config;
    const user_id = params.user_id || '';
    // these URL does not need token
    if (url === REST_URL.GET_USER || url === REST_URL.GET_USER_TOKEN) {
      return '';
    }
    const storageItem = localStorage.getItem(MARKETPLACE_TOKEN);
    const savedToken = !!storageItem ? JSON.parse(storageItem) : null;

    if (!savedToken || isTokenExpired(savedToken)) {
      refreshRequest = refreshRequest ? refreshRequest : refreshToken(user_id);
      const userToken = await refreshRequest;
      if (!userToken) {
        refreshRequest = null;
        return '';
      } else {
        localStorage.setItem(MARKETPLACE_TOKEN, JSON.stringify(userToken));
        refreshRequest = null;
        return userToken.token;
      }
    } else {
      return savedToken.token;
    }
  } catch (error) {
    refreshRequest = null;
    return '';
  }
};

export const refreshToken = async (user_id: string) => {
  return await MarketplaceServices.getUserToken(user_id);
};
export const isRequireMarketplaceToken = (config: any, service: any) => {
  const isGlobalSearchURL = config.url === REST_URL.GLOBAL_SEARCH;
  const isMarketplaceURL = config.baseURL === handleBaseURL(service?.marketplaceApiSuffix);
  const isOrderURL = config.baseURL === handleBaseURL(service?.orderApiSuffix);
  const isApprovalURL = config.url === REST_URL.GET_OPEN_SUPPORT_ACTIVITIES;
  return isGlobalSearchURL || isMarketplaceURL || isOrderURL || isApprovalURL;
};

const isTokenExpired = (token: any) => {
  return !!token ? token.exp * 1000 <= Date.now() : true;
};
